import {ComandaOrder} from "../types/PostCommand";
import {Divider} from "@mantine/core";
import React, {useEffect, useState} from "react";
import { deleteCommand} from "../network/controllers/CommandController";
import {RestaurantStatusEnum} from "../enums/RestaurantStatusEnum";
import {showWarningNotification} from "../utils/NotificationUtils";
import GenericTooltip from "./generic/GenericTooltip";

import Barcode from 'react-barcode';

export default function CommandClientCardComponent(props: { order: ComandaOrder }) {
    const totalPrice = props.order.dishes.reduce((acc, dish) =>
        acc + ((dish.priceOriginal + dish.price) * dish.quantity), 0);

    useEffect(() => {
        console.log('diocane',props.order)
    }, [props.order]);

    const formatDate = (dateString: string) => {
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return "Data non disponibile";
            }
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${day}/${month}/${year} ${hours}:${minutes}`;
        } catch {
            return "Data non disponibile";
        }
    };

    const [dateTimeData, setDateTimeData] = useState<Date | null>(new Date(props.order.delivery));



    return (
        <div className={'w-auto mx-4 rounded-2xl border-t-4 shadow-lg shadow-black '}>
            <div className={'w-full h-full b'}>
                <div key={props.order.id} className="w-full h-full p-5 my-5">
                    <p className={`w-full h-full bg-black rounded-2xl  font-poppins-bold text-2xl text-amber-400`}>
                        {props.order.type === RestaurantStatusEnum.DELIVERY ? 'DOMICILIO' : props.order.type}
                    </p>

                    <div className="flex mt-5 p-2">
                        <div className="w-full h-auto flex flex-col">
                            <p className={'font-poppins-regular'}><strong>Creato
                                il:</strong> {formatDate(props.order.bookingDate)}</p>

                            <div className={'flex items-center'}>
                                <p className={'font-poppins-regular'}><strong>Orario consegna
                                    ordine:</strong> {dateTimeData ? formatDate(new Date(dateTimeData.getTime() - 3600000).toISOString()) : ''} </p>
                            </div>

                            <p className={'font-poppins-regular'}>
                                <strong>Cliente:</strong> {props.order.name} {props.order.surname}</p>
                            <p className={'font-poppins-regular'}><strong>N.
                                Telefono:</strong> {props.order.phoneNumber}</p>
                            <p className={'font-poppins-regular mb-5'}
                               style={{
                                   visibility: props.order.type === 'DELIVERY' ? 'visible' : 'hidden',
                                   height: 'auto',
                                   marginBottom: '1rem'
                               }}><strong>Indirizzo:</strong> {props.order.address || "\u00A0"}
                            </p>


                        <div className="w-full h-auto flex items-center justify-center ">
                            {props.order.codeBarcode &&
                                <Barcode
                                    value={props.order.codeBarcode.toString()}
                                    width={2}
                                    height={50}
                                    fontSize={14}
                                    displayValue={true}
                                    background={'transparent'}
                                />
                            }
                        </div>
                    </div>
                    </div>
                    <Divider color={'dark'} size={'lg'}/>
                    <p className={'w-full h-auto font-poppins-regular text-lg text-center py-2'}>
                        <strong>I MIEI ORDINI</strong>
                    </p>

                    <ul className="h-64 overflow-y-auto py-3">
                        {props.order.dishes.map((dish, index) => (
                            <li key={index} className="flex justify-between">
                                <div className="flex flex-col mt-2">
                                    <p className="font-poppins-regular text-sm mt-2 flex justify-start ">
                                        <strong>{dish.nameProduct} {dish.quantity}X €{(dish.priceOriginal + dish.price).toFixed(2)}</strong>
                                    </p>
                                    <p className="font-poppins-regular ml-10 flex justify-start items-start ">
                                        {dish.ingredients && dish.ingredients.length > 0 ?
                                            dish.ingredients
                                                .filter(ing => ing.statusIngredient === "ADD" || ing.statusIngredient === "REMOVE")
                                                .map(ing => {
                                                    if (ing.statusIngredient === "REMOVE") {
                                                        return `-${ing.name}`
                                                    } else if (ing.statusIngredient === "ADD") {
                                                        return `+${ing.name}`
                                                    }
                                                    return ''
                                                })
                                                .filter(Boolean)
                                                .join(', ')
                                            : ''
                                        }
                                    </p>
                                </div>
                                <p className="font-poppins-regular whitespace-nowrap mt-3 ">
                                    <strong>€ {((dish.priceOriginal + dish.price) * dish.quantity).toFixed(2)}</strong>
                                </p>
                            </li>
                        ))}
                    </ul>

                    <Divider color={'dark'} size={'lg'}/>
                    <div className={'flex justify-between mt-5'}>
                        <p className={'font-poppins-regular'}><strong>Totale</strong></p>
                        <p className={'font-poppins-regular'}><strong>€ {totalPrice.toFixed(2)}</strong></p>
                    </div>

                    <div
                        className={`${props.order.status !== "COMPLETA" ? 'visible' : 'invisible'} w-full h-full flex gap-x-3 p-4 justify-center items-center`}>

                        <GenericTooltip
                            innerHtml={
                                <div
                                    className={`bg-opacity-100 hover:scale-110 duration-700 pointer-events-auto cursor-pointer bg-yellow rounded-xl w-[175px] h-[3rem] flex flex-col justify-center items-center px-1`}
                                    onClick={() => {
                                        showWarningNotification(
                                            `Sei sicuro di voler eliminare l ordine di ${props.order.name} ${props.order.surname}?`,
                                            () => {
                                                deleteCommand(true, [props.order.id], (response) => {
                                                    window.location.reload();
                                                })
                                            }
                                        )
                                    }}>
                                    <p className={`font-poppins-bold text-[14px] w-full text-center`}>{'Elimina Comanda'}</p>
                                </div>
                            }
                            txt={'Clicca per annullare e eliminare la comanda'}
                        />


                    </div>
                </div>
            </div>
        </div>
    );
}
